import $ from 'jquery';

$(document).ready(function() {
    $('.js-museum-calendar').each(function() {
        $(this).dateRangePicker({
        	singleMonth: true
        }).bind('datepicker-close', function() {
			$('.js-museum-calendar-button').removeClass('active');
		});
    });
    $(document).on('click', '.js-museum-calendar-button', function() {
		$(this).addClass('active');
		let width = 0,
			widthCal = 0,
			offsetLeft = 0;
		width = $('.js-museum-calendar').width();
		widthCal = $('.date-picker-wrapper').width();
		offsetLeft = $('.js-museum-calendar').offset().left;
		$('.date-picker-wrapper').css('left', (offsetLeft + (width - widthCal)) + "px");
	});
	$('body').on('click', function(e) {
		if (!((e.target).closest('.js-museum-calendar-button'))) {
			$('.js-museum-calendar-button').removeClass('active');
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-calendar.js